export default {"src":"/_next/static/media/footer-apple-badge.b32be7bb.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};